import { Message, toaster } from "rsuite";

export const toastWarning = (message = '') => {
    if (!message) {
        return;
    }

    toaster.push(
        <Message showIcon type="warning">
            {message}
        </Message>,
    );
}